import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import * as ace from "ace-builds";
import { Model } from 'src/logic/model';
import { text } from 'src/services/text.service';
import { Act } from 'src/logic/act';
import { Actions } from '../../logic/enum/actions';
import { OperationParam } from 'src/logic/enum/operation-param';
import { SnippetSearchResultItem } from 'src/logic/types/snippetSearchResultItem';
import { AppViewStates } from 'src/logic/enum/app-view-states';
import { ItemStates } from 'src/logic/enum/item-states';
import { Constants } from 'src/logic/constants';

@Component({
    selector: 'app-snippets',
    templateUrl: './snippets.component.html',
    styleUrls: ['./snippets.component.less'],
    standalone: false
})
export class SnippetsComponent implements OnInit {

  text = text;
  ItemStates = ItemStates;
  Constants = Constants;  
  
  @ViewChild("editor")
  private editor!: ElementRef<HTMLElement>;

  aceEditor: ace.Ace.Editor | null = null;

  ngAfterViewInit(): void {
    // this.newSnippetInitAce();
    
    // this.model.snippetSearchVal = 'sel';
    // this.searchKeyUp();
  }

  constructor(public model: Model,  public act: Act) { }

  ngOnInit(): void {
    //ace.config.set("fontSize", "14px");
    // (<any>this.editor.nativeElement).placeholder = this.text.of('placeholder Paste Code');
    // console.log('hljs',hljs);
  }

  // newSnippetInitAce(){
    // setTimeout(()=>{
    //   this.aceEditor = ace.edit(this.editor.nativeElement);
      
    //   this.aceEditor.setTheme("ace/theme/chrome");
    //   // aceEditor.getSession().setMode("ace/mode/sql");
    //   this.aceEditor.getSession().setMode("ace/mode/javascript");

    //   this.aceEditor.getSession().setUseWorker(false);

    //   this.aceEditor.renderer.setShowGutter(false);
    //   this.aceEditor.focus();
    // },0);
  // }

  newSnippetClick() {
    if(this.model.snippetState == ItemStates.Create){
      this.ChangeSnippetState(ItemStates.None);
    } else {
      this.ChangeSnippetState(ItemStates.Create);
    }    
  }

  snippetSave() { 
    if(this.aceEditor){
    this.model.snippetEditItem.value = this.aceEditor.getValue();
    if(this.model.snippetState == ItemStates.Create){
      this.act.do(Actions.snippet, { operation: OperationParam.Add });
    }else if(this.model.snippetState == ItemStates.Edit){
      this.act.do(Actions.snippet, { operation: OperationParam.Update });
    }
    }
  }

  snippetSaveCancel() {
    this.ChangeSnippetState(ItemStates.None);
  }

  snippetDelete(snippet: SnippetSearchResultItem){
    if(this.model.saving())
      return;
    this.act.do(Actions.snippet, { operation: OperationParam.Del, snippet });
  }

  searchKeyUp(){
    if(this.model.snippetSearchVal.length > 2){
      this.act.do(Actions.snippetSearch);
    }
  }

  snippetGroupChange(){
    if(this.model.snippetSearchVal.length > 2){
      this.act.do(Actions.snippetSearch);
    }
  }

  snippetCopyClick(snippet: SnippetSearchResultItem){
    navigator.clipboard.writeText(snippet.TxtValue ?? '');
  }

  snippetEditClick(snippet: SnippetSearchResultItem){
    this.ChangeSnippetState(ItemStates.Edit, snippet);
    window.scrollTo(0,0);
  }

  snippetToRelacing(snippet: SnippetSearchResultItem){
    this.model.replacingScriptText = snippet.TxtValue;
    this.act.do(Actions.changeAppViewState, AppViewStates.code);
    setTimeout(()=>{
      this.model.replacingScriptAceEditor?.setValue(snippet.TxtValue, 0);
      document.getElementById('divScript')?.scrollIntoView();
    }, 0);
  }

  searchSnippetsClick(){
    this.act.do(Actions.snippetSearch);
  }

  ChangeSnippetState(newState: ItemStates, snippet: SnippetSearchResultItem | null = null){
    this.model.snippetState = newState;
    
      switch(newState){
        case ItemStates.Create:
          this.model.snippetEditItem.value = '';
          this.model.snippetEditItem.description = '';
          this.model.snippetEditItem.id = 0;
          this.model.snippetEditItem.mode = this.model.snippetEditItem.mode ?? Constants.aceModeDefault;
          setTimeout(() => {
            this.aceInit();
            this.aceEditor?.getSession().setValue('');
            this.aceEditor?.focus();
          });
        break;

        case ItemStates.Edit:
          setTimeout(() => {
            this.aceInit();
            this.model.snippetEditItem.value = '';
            this.model.snippetEditItem.description = snippet?.Description ?? '';
            this.model.snippetEditItem.id = snippet?.Id ?? 0;
            this.model.snippetEditItem.mode = snippet?.Mode ?? Constants.aceModeDefault;

            this.aceEditor?.getSession().setValue(snippet?.TxtValue ?? '');
            this.aceEditor?.getSession().setMode(`ace/mode/${this.model.snippetEditItem.mode}`);
            this.aceEditor?.focus();
          });
        break;

        case ItemStates.None:
          this.model.snippetEditItem.value = '';
          this.model.snippetEditItem.description = '';
          this.model.snippetEditItem.id = 0;
        break;
      }
  }

  aceInit(){
    this.aceEditor?.destroy();
    this.aceEditor = ace.edit(this.editor.nativeElement);
    this.aceEditor.setTheme("ace/theme/chrome");
    this.aceEditor.getSession().setMode(`ace/mode/${this.model.snippetEditItem.mode}`);
    this.aceEditor.getSession().setUseWorker(false);
    this.aceEditor.renderer.setShowGutter(false);
  }

  editItemModeChange(){
    this.aceEditor?.getSession().setMode(`ace/mode/${this.model.snippetEditItem.mode}`);
  }

  // bindPasteListener(){
  //   window.addEventListener("paste", (ev: any) => {
  //       this.retrieveImageFromClipboardAsBlob(ev, (imageBlob)=>{
  //         this.clearMsgSave();
  //         if(imageBlob){
  //           let newItem = new NewSubItemModel();
  //           newItem.type = ItemTypeEnum.Image;
  //           var reader = new FileReader();
  //           reader.readAsDataURL(imageBlob); 
  //           reader.onloadend = ()=> {
  //               newItem.fileData = reader.result; 
  //               this.items.push(newItem);   
  //           }
  //         }
  //     });
  //   }, false);      
  // }
  
  // retrieveImageFromClipboardAsBlob(pasteEvent, callback){
  //   if(pasteEvent.clipboardData == false){
  //         if(typeof(callback) == "function"){
  //             callback(undefined);
  //         }
  //     };
  
  //     var items = pasteEvent.clipboardData.items;
  
  //     if(items == undefined){
  //         if(typeof(callback) == "function"){
  //             callback(undefined);
  //         }
  //     };
  
  //     for (var i = 0; i < items.length; i++) {
  //         // Skip content if not image
  //         if (items[i].type.indexOf("image") == -1) continue;
  //         // Retrieve image on clipboard as blob
  //         var blob = items[i].getAsFile();
  
  //         if(typeof(callback) == "function"){
  //             callback(blob);
  //         }
  //     }
  // }
}
